export default ({
    "1": "启用预置资源",
    "2": "引用系统资源库",
    "3": "引用共享资源库",
    "4": "引用个人资源库",
    "5": "引用来源“我的收藏”",
    "6": "启用预置试卷",
    "7": "引用共享试卷",
    "8": "编辑试卷",
    "9": "复制试卷",
    "10": "新建练习试卷",
    "11": "引用公共习题库",
    "12": "引用个人习题",
    "13": "引用错题库习题",
    "14": "新建问题探究",
    "15": "备课推送",
    "16": "层次推送",
    "17": "添加课时",
    "18": "备课分享",
    "19": "查看分享方案",
    "20": "引用分享方案",
    "21": "新建试题-填空题",
    "22": "新建试题-判断题",
    "23": "新建试题-听力选择题",
    "24": "上传听力材料-本地上传",
    "25": "上传听力材料-资源库选取",
    "26": "试卷复制",
    "27": "学生点击课时",
    "28": "学生点击课堂资源",
    "29": "学生收藏资源",
    "30": "学生查看收藏资源",
    "31": "学生点击课堂试卷",
    "32": "学生提交试卷",
    "33": "学生上传答案",
    "34": "学生显示解析",
    "35": "学生错题归类",
    "36": "学生查看学情分析",
    "37": "学生查看单题详情",
    "38": "学生查看主观题",
    "39": "学生查看本节错题",
    "40": "学生收藏习题",
    "41": "学生查看全部错题",
    "42": "学生查看全部收藏",
    "43": "学生查看全部提问",
    "44": "学生提问",
    "45": "白板互动",
    "46": "学情统计",
    "47": "学情统计-多班级对比事件",
    "48": "学情统计停留时长",
    "49": "错题统计",
    "50": "错题统计-展开按钮",
    "51": "错题统计停留时长",
    "52": "资源统计",
    "53": "学情统计停留时长",
    "54": "点击上课按钮",
    "55": "上课播放音视频",
    "56": "暂停音视频播放",
    "57": "上课展示材料",
    "58": "上课点击PPT",
    "59": "全屏模式",
    "60": "当堂推送",
    "61": "上课问题探究",
    "62": "课堂互动",
    "63": "计时启动",
    "64": "计时放大",
    "65": "计时器最小化关闭",
    "66": "抢答",
    "67": "随机点名",
    "68": "锁屏",
    "69": "解锁",
    "70": "投屏",
    "71": "白板",
    "72": "白板-分享",
    "73": "学情分析",
    "74": "未提交学生名单",
    "75": "题目统计查看",
    "76": "客观题展开答题详情",
    "77": "平均正确率—小组",
    "78": "查看主观题",
    "79": "查看未上传学生",
    "80": "主观题批改",
    "81": "主观题点评",
    "82": "主观题评分",
    "83": "主观题分享",
    "84": "查看已批",
    "85": "查看未批",
    "86": "打开解析",
    "87": "学习统计",
    "88": "课堂问题",
    "89": "分组查看",
    "90": "主观题批改-工具栏-橡皮擦",
    "91": "主观题批改-工具栏-清空",
    "92": "主观题批改-工具栏-撤销",
    "93": "主观题批改-工具栏-拖动",
    "94": "主观题批改-置顶",
    "95": "快速批改-对",
    "96": "快速批改-错",
    "97": "快速批改-半对",
    "98": "老师-个人中心",
    "99": "我的试题-修改",
    "100": "问题反馈",
    "101": "学生-个人中心",
    "102": "老师端-习题-收藏",
    "103": "老师端-习题-补充资料",
    "104": "主观题批改-按学生查看",
    "106": "主观题批改-颜色",
    "107": "主观题批改-线宽",
    "108": "主观题批改-放大",
    "109": "主观题批改-缩小",
    "110": "旋转",
    "111": "回答课堂问题",
    "112": "白板-保存",
    "113": "白板-打开",
    "114": "白板-新建",
    "115": "学生平均正确率排名",
    "117": "资源包试卷编辑次数",
    "118": "引用系统库试卷",
    "119": "引用预置图片资源",
    "120": "引用预置音视频资源",
    "121": "引用预置文档资源",
    "122": "引用预置PPT资源",
    "123": "引用系统资源库图片",
    "125": "资源包PPT查看",
    "126": "资源包试卷查看",
    "127": "引用系统资源库音视频",
    "128": "引用系统资源库文档",
    "129": "引用系统资源库PPT",
    "130": "引用共享资源库图片",
    "131": "引用共享资源库音视频",
    "132": "引用共享资源库文档",
    "133": "引用共享资源库PPT",
    "134": "引用个人资源库图片",
    "135": "引用个人资源库音视频",
    "136": "引用个人资源库文档",
    "137": "引用个人资源库PPT",
    "138": "更多资源",
    "139": "备课PPT查看",
    "140": "备课文档查看",
    "141": "引用我的收藏中的图片",
    "142": "引用我的收藏中的音视频",
    "143": "引用我的收藏中的文档",
    "144": "引用我的收藏中的PPT",
    "145": "新建口语测评",
    "146": "清空所有",
    "147": "按学生查看",
    "148": "播放学生音频",
    "149": "说明",
    "150": "点击原声",
    "151": "点击跟读",
    "152": "点击回放",
    "153": "按题目查看",
    "154": "查看其他学生",
    "155": "学生播放音频",
    "156": "引用共享资源库第三方",
    "157": "引用共享试卷库第三方",
    "158": "引用共享第三方习题",
    "159": "引用爱米习题",
    "160": "引用共享习题",
    "161": "查看题目",
    "162":"新建答题卡练习",
    "163":"上传试卷",
    "164":"选择试卷",
    "165":"展开题目设置",
    "166":"引用答题卡",
    "167":"编辑答题卡",
    "168":"复制答题卡",
    "169":"完成详情",
    "170":"设置组距",
    "171":"成绩单",
    "172":"试卷查看",
    "173":"显示答案",
    "174":"点击登录",
    "175":"重置密码",
    "176":"学生提交答题卡",
    "240":"一起练题入口",
    "241":"新建限时训练",
    "242":"引用限时训练",
    "243":"推送记录",
    "244":"分享记录",
    "245":"撤销分享",
    "246":"删除分享",
    "247":"新建试题-听力填空题",
    "248":"信号灯",
    "249":"信号灯-再来一次",
    "250":"投票器",
    "251":"计分器",
    "252":"计分器-保存",
    "253":"计分器-历史",
    "254":"计分器-继续计分",
    "255":"计分器-清零",
    "256":"计分器-全部+1",
    "257":"计分器-全部-1",
    "258":"计分器-排序",
    "259":"前去查看",
    "260":"学生投票器",
    "262":"放大镜",
    "263":"放大镜-聚光",
    "264":"放大镜-2x",
    "265":"放大镜-1.5x",
    "266":"放大镜-1.0x",
    "267":"聚光灯",
    "268":"聚光灯-切圆",
    "269":"聚光灯-切方",
    "270":"聚光灯-2x",
    "271":"聚光灯-1.5x",
    "272":"聚光灯-1.0x",
    "285":"投图",
    "286":"计时器",
    "287":"白板-图形",
    "298":"资源下载",
    "299":"转发",
    "300":"资源包分享页面PV",
    "301":"备课-上传资源",
    "302":"个人中心-上传资源",
    "303":"打印试卷",
    "305":"下载试卷",
    "306":"在线PPT",
    "307":"在线PDF",
    "308":"本地PPT",
    "309":"上课展示试卷"
})
